/* src/app/views/template/components/templates/digital/digital-templates-container/digital-templates-container.component.scss */
/*# sourceMappingURL=digital-templates-container.component.css.map */
